<div class="localization-preview-view">
  <div class="widget-container">
    <div class="icon-and-name">
      <svg-icon src='./assets/icons/Project_icon.svg'
                title="{{'localizationForm.preview.selectedWidgetTitleInfo' | translate }}"
                class="menu-action-icon svg-icon-red">
      </svg-icon>
      <h4 class="widget-name-title">
        {{widgetData?.title}}
      </h4>
    </div>
    <div class="separator"></div>
    <div *ngIf="widgetData" (click)="widgetDisplay(event)" class="label">
      <div class="chevron" [ngClass]="{'chevron-rotate':isWidgetDisplayed}">
        <svg-icon src='./assets/icons/chevron-down-solid.svg' class="raci-participants svg-icon-gray"></svg-icon>
      </div>
    </div>
  </div>

  <div class="localization-preview-body" *ngIf="editingLanguageForm">
    <div *ngIf="isWidgetDisplayed && widgetData" class="widget-preview-description">
      <div class="participants-description-bold">
        <p>{{'localizationForm.preview.selectedWidgetTitleInfo' | translate }}</p>
      </div>
      <div style="width: 100%;" *ngIf="widgetData">
        <localization-widget [translationData]="widgetData"></localization-widget>
      </div>
    </div>
    <div *ngIf="!editingLanguageForm.valid" [ngClass]="{'warning-below': isWidgetDisplayed, 'warning': !isWidgetDisplayed}">
      <p>
        <strong>WARNING</strong>: Multiple invalid hashtag names detected. Only alphanumeric characters are allowed!<br />
        These hashtags can be saved temporarily, but they will <strong>NOT</strong> work in the Report Designer!
      </p>
    </div>
    <div class="grid-data-container">
      <kendo-grid [data]="widgetData?.labels"
                  #dataGrid
                  class="kendo-white-grid approval-grid"
                  [class.is-default-language]="isDefault"
                  [selectable]="selectableSettings">

        <kendo-grid-column [headerClass]="'participants-grid'"
                           field="termName"
                           [title]="'localizationForm.preview.termNameTitle' | translate"
                           [width]="auto">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span title="{{ dataItem.termName }}">{{ dataItem.termName }}</span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [headerClass]="'participants-grid'"
                           field="group"
                           [title]="'localizationForm.preview.groupTitle' | translate"
                           [width]="115">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span title="{{ dataItem.group }}">{{ dataItem.group }}</span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [headerClass]="'participants-grid'"
                           field="defaultLanguageValue"
                           [title]="'localizationForm.preview.valueDefaultLangTitle' | translate"
                           [width]="350">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span title="{{ dataItem.defaultLanguageValue }}">{{ dataItem.defaultLanguageValue }}</span>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [headerClass]="'participants-grid'"
                           field="editedLanguageValue"
                           [title]="'localizationForm.preview.valueEditLangTitle' | translate"
                           [width]="350">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <input [formControl]="editingLanguageForm.controls.editingLanguageValues.controls[rowIndex]"
                   [name]="'valueEditLang' + rowIndex"
                   class="k-textbox textbox-dotted"
                   (input)="onInputChange(rowIndex, $event)"
                   [title]="dataItem.editedLanguageValue">
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column [headerClass]="'participants-grid'"
                           field="hashTagName"
                           [title]="'localizationForm.preview.hashtagNameTitle' | translate"
                           [width]="115" *ngIf="widgetData && !widgetData.hashtagDisabled">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <input [formControl]="editingLanguageForm.controls.hashTagNames.controls[rowIndex]"
                   [class.invalid]="editingLanguageForm.controls.hashTagNames.controls[rowIndex].invalid"
                   [name]="'hashtagName' + rowIndex"
                   class="k-textbox textbox-dotted-when-default"
                   (input)="onHashtagInputChange(rowIndex, $event)"
                   [title]="dataItem.hashTagName">
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </div>
  </div>
</div>
<ref-list-translate-dialog *ngIf="showRefListTranslateDialog" [referenceListid]="selectedField.sqlReferenceTable"
[fieldName]="selectedField.termName" [fieldId]="selectedField.oid" (close)="closeRefListTranslateDialog()">
</ref-list-translate-dialog>
